import { getUserMailboxInfo } from 'owa-client-ids';
import { userConfigurationSet } from 'owa-session-store';
import { orchestrator } from 'satcheljs';
import { selectedCalendarsUpdated } from '../actions/publicActions';
import {
    updateSelectedCalendarsInStore,
    formatInitialSelectedCalendars,
} from '../actions/internalActions';
import { isConversionNeeded } from 'owa-immutable-id-store';

/**
 * When the user configuration is set for an account, updated the selected calendars in this store,
 * and dispatch a `selectedCalendarsUpdated` to let consumers know that the store value has changed
 */
orchestrator(userConfigurationSet, actionMessage => {
    const { userConfiguration, userIdentity } = actionMessage;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (20,23): Object is possibly 'undefined'.
    // @ts-expect-error
    let calendarIds = userConfiguration.ViewStateConfiguration.SelectedCalendarsDesktop;
    const primaryAddress = userIdentity ? userIdentity : getUserMailboxInfo().userIdentity;

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (26,28): Argument of type 'string[] | undefined' is not assignable to parameter of type '(string | null | undefined)[]'.
    // @ts-expect-error
    if (isConversionNeeded(calendarIds, primaryAddress)) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (30,40): Argument of type 'string[] | undefined' is not assignable to parameter of type 'string[]'.
        // @ts-expect-error
        formatInitialSelectedCalendars(calendarIds, primaryAddress);
    } else {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (35,40): Argument of type 'string[] | undefined' is not assignable to parameter of type 'string[]'.
        // @ts-expect-error
        updateSelectedCalendarsInStore(calendarIds, primaryAddress);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (39,34): Argument of type 'string[] | undefined' is not assignable to parameter of type 'string[]'.
        // @ts-expect-error
        selectedCalendarsUpdated(calendarIds, primaryAddress);
    }
});
